import { render, staticRenderFns } from "./addable-custom-select.vue?vue&type=template&id=c67ffbea"
import script from "./addable-custom-select.vue?vue&type=script&lang=js"
export * from "./addable-custom-select.vue?vue&type=script&lang=js"
import style0 from "./addable-custom-select.vue?vue&type=style&index=0&id=c67ffbea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports